import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.name === 'document-chapter') return false
    if (
      to.name === 'document' &&
      typeof to.hash === 'string' &&
      to.hash.startsWith('#part-')
    ) {
      return false
    }
    return { top: 0, left: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/biografie',
      name: 'biography',
      component: () => import('../views/BiographyView.vue'),
    },
    {
      path: '/werk',
      name: 'works',
      component: () => import('../views/WorksView.vue'),
      redirect: '/verzamelde-werken',
      children: [
        {
          path: '/publicaties',
          name: 'publications',
          component: () => import('../views/PublicationsView.vue'),
        },
        {
          path: '/verzamelde-werken',
          name: 'documents',
          component: () => import('../views/DocumentsView.vue'),
        }
      ]
    },
    {
      path: '/publicaties/:slug',
      name: 'publication',
      component: () => import('../views/DocumentView.vue'),
    },
    {
      path: '/verzamelde-werken/:no/inhoudsopgave',
      name: 'document-inhoudsopgave',
      component: () => import('../views/DocumentChaptersView.vue'),
    },
    {
      path: '/verzamelde-werken/:no/:chapterSlug',
      name: 'document-chapter',
      component: () => import('../views/DocumentChapterView.vue'),
    },
    {
      path: '/verzamelde-werken/:no',
      name: 'document',
      component: () => import('../views/DocumentView.vue'),
    },
    {
      path: '/stichting',
      name: 'foundation',
      component: () => import('../views/FoundationView.vue'),
    },
    {
      path: '/doneer',
      name: 'donation',
      component: () => import('../views/DonationView.vue'),
    },
    {
      path: '/doneer/callback/:uuid',
      name: 'donation_callback',
      component: () => import('../views/DonationView.vue'),
    },
    {
      path: '/algemene-voorwaarden',
      name: 'terms',
      component: () => import('../views/TermsView.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('../views/NotFoundView.vue'),
    },
  ],
})

router.beforeEach((_, from) => {
  window.localStorage.setItem('prevPath', String(from.path))

  if (from.name) {
    window.localStorage.setItem('prevRoute', String(from.name))
  } else {
    window.localStorage.removeItem('prevRoute')
  }
})

export default router
